import { useState } from 'react';
// eslint-disable-next-line import/no-named-as-default-member
import createFacet from '../../../classes/facets/FacetFactory';
import AdvancedSearchUtility from '../../../utility/AdvancedSearchUtility';

const useFilters = ({ initialFilters = [], searchType }) => {
  const [filters, setFilters] = useState(initialFilters);
  const addFilter = (newFilter) => {
    setFilters((prevFilters) => [...prevFilters, newFilter]);
  };

  /* istanbul ignore next */
  const getFilterByFacetTypeId = (filterId) => filters
    .filter((filter) => filter.facetId === filterId);

  const updateFilters = (updatedFilter, facetTypeId) => {
    const uneditedFilters = filters
      .filter((filter) => filter.facetId !== facetTypeId);
    setFilters([...uneditedFilters, ...updatedFilter]);
  };

  const removeFilter = (facetTypeIdToRemove) => setFilters(filters
    .filter((filter) => filter.facetId !== facetTypeIdToRemove));

  /* istanbul ignore next */
  const getFilterTooltip = (facetTypeId) => {
    const filteredFiltersByTypeId = getFilterByFacetTypeId(facetTypeId);
    const FacetClass = createFacet(facetTypeId);
    return FacetClass.getTooltip(
      AdvancedSearchUtility.sortFiltersByOperatorType(
        filteredFiltersByTypeId,
      ),
      searchType,
    );
  };

  return {
    filters,
    setFilters,
    updateFilters,
    removeFilter,
    addFilter,
    getFilterTooltip,
    getFilterByFacetTypeId,
  };
};

export default useFilters;
